import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { PrimeReactProvider } from 'primereact/api';
import { ConfirmPopup } from 'primereact/confirmpopup';
import { Toast } from 'primereact/toast';
import { CmsApiBaseProvider } from '../cms/api-context';
import { cmsStore } from './store';
import { CmsAccountBootstrap } from './cms-account-bootstrap';
import { setCmsApiErrorToastTarget } from 'shared/lib/util/cms-api-error-toast';
import { createCmsQueryClient } from './query-client';
/**
 * API base URL, Redux store, toast target for axios errors, and PrimeReact overlays used by CMS screens.
 */
export const CmsProviders = ({ apiBaseUrl, getAccessToken, getWalletAccessToken, walletApiBase, children, }) => {
    const bindToast = useCallback((instance) => {
        setCmsApiErrorToastTarget(instance);
    }, []);
    const queryClient = useMemo(() => createCmsQueryClient(), []);
    const primeReactConfig = useMemo(() => ({
        ripple: true,
        inputStyle: 'outlined',
        pt: {
            dialog: {
                root: { className: 'cms-mfe-dialog' },
            },
        },
    }), []);
    return (_jsx(PrimeReactProvider, { value: primeReactConfig, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(CmsApiBaseProvider, { baseUrl: apiBaseUrl, getAccessToken: getAccessToken, getWalletAccessToken: getWalletAccessToken, walletApiBase: walletApiBase, children: _jsxs(Provider, { store: cmsStore, children: [_jsx(CmsAccountBootstrap, {}), _jsx(ConfirmPopup, {}), _jsx(Toast, { ref: bindToast, position: "top-right", className: "cms-mfe-toast-host" }), _jsx("div", { className: "cms-mfe-providers-body", children: children })] }) }) }) }));
};
